<template>
  <v-main>
    <header-components></header-components>
    <title-components></title-components>
    <v-container
      class="mx-auto mt-6"
      style="max-width: 1200px;"
    >
      <progress-components page="patient"></progress-components>
      <v-form ref="form" class="mt-12">
        <interview-link></interview-link>
        <v-card
          class="mx-auto mt-1"
          elevation="1"
          outlined
        >
          <v-card-title>
            <strong>患者氏名</strong><span class="text-red"><strong> *</strong></span>
          </v-card-title>
          <v-responsive
            class="mx-5"
            max-width="344"
          >
            <v-text-field
              label="回答を入力"
              variant="underlined"
              :rules="[required]"
              v-model="name"
            ></v-text-field>
          </v-responsive>
        </v-card>
        <v-card
          class="mx-auto mt-6"
          elevation="1"
          outlined
        >
          <v-card-title>
            <strong>主訴</strong><span class="text-red"><strong> *</strong></span>
          </v-card-title>
          <v-responsive
            class="mx-5"
            max-width="344"
          >
            <v-text-field
              label="回答を入力"
              variant="underlined"
              :rules="[required]"
              v-model="mainSymptom"
            ></v-text-field>
          </v-responsive>
        </v-card>
      </v-form>
    </v-container>
    <v-container>
      <v-row v-if="fromConfirm" justify="center" align-content="center" class="mb-6">
        <v-btn
          dark
          color="doorAccentColor"
          x-large min-width="362px" class="mb-4 mx-4"
          @click="clickedNextPage"
        >確認
        </v-btn>
      </v-row>
      <v-row v-else justify="center" align-content="center" class="mb-6">
        <v-btn
          dark
          color="#B0B6BA"
          x-large min-width="362px" class="mb-4 mx-4"
          @click="toBack"
        >戻る
        </v-btn>
        <v-btn
          dark
          x-large min-width="362px"
          color="doorAccentColor"
          class="mb-4 mx-4 white--text"
          @click="clickedNextPage"
        >次へ
        </v-btn>
      </v-row>
    </v-container>
    <footer-components></footer-components>
  </v-main>
</template>
<script>
import { defineComponent, computed, ref } from 'vue'
import { Logger } from 'aws-amplify'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import HeaderComponents from '@/components/InterviewHeader.vue'
import FooterComponents from '@/components/InterviewFooter.vue'
import TitleComponents from '@/components/MedicalRecordTitle.vue'
import ProgressComponents from '@/components/MedicalRecordProgress.vue'
import InterviewLink from '@/components/InterviewLink.vue'
import { useScreenOperation } from '@/func/useScreenOperation'
import { useFormValidator } from '@/func/useFormValidator'

const logger = new Logger('AdvanceForm');

export default defineComponent({
  components: {
    'header-components': HeaderComponents,
    'footer-components': FooterComponents,
    'title-components': TitleComponents,
    'progress-components': ProgressComponents,
    'interview-link': InterviewLink
  },
  setup() {
    const { scrollToTop, fromConfirmScreen, scrollToErrorPosition } = useScreenOperation()
    const fromConfirm = computed(() => fromConfirmScreen())
    const { required } = useFormValidator()
    const form = ref(null)

    logger.info('MedicalRecord Patient')
    scrollToTop()

    const store = useStore()
    const name = computed({
      get: () => store.state.advanceInterview.name,
      set: (value) => store.dispatch('advanceInterview/setName', value)
    })
    const mainSymptom = computed({
      get: () => store.state.medicalRecord.mainSymptom,
      set: (value) => store.dispatch('medicalRecord/setMainSymptom', value)
    })

    const router = useRouter()
    const toBack = () => router.go(-1)

    const clickedNextPage = async () => {
      const result = await form.value.validate()
      if (!result.valid) {
        scrollToErrorPosition()
        return
      }
      if (fromConfirm.value) {
        router.push('/record/confirm')
      } else {
        router.push('/record/consultation')
      }
    }
    return {
      fromConfirm,
      clickedNextPage,
      toBack,
      name,
      mainSymptom,
      required,
      form
    }
  }
})
</script>
